<script>
  import PatioService from '../../../../domain/patio/services/patio'
  import { isArray } from 'lodash'
  import estadosBr from '../../../_default/utils/estados-brasileiros'
  import { VueMaskDirective as mask } from 'v-mask'
  import {REAL_BRL} from '../../../../utils/helpers/money'
  import { VMoney } from 'v-money'

  export default {
    components: {},
    nome: 'novo-patio',
    directives: {mask, money: VMoney},
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          nome: null,
          codigo: 0,
          porcentagemBoleto: 0.0,
          naoEmitirBoleto: false,
          metaVeiculos: 0,
          metaArrecadacao: 0,
          capacidade: '',
          inscricaoMunicipal: '',
          endereco: '',
          complemento: '',
          estado: null,
          cidade: '',
          cep: '',
          observacao: '',
          horarioAtendimento: '',
          razaoSocial: '',
          cnpj: '',
          telefone: ''
        }
      }
    },
    computed: {
      estadosBr () {
        return estadosBr
      }
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          PatioService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        const request = this.prepararDados()
        console.log(request)
        this.$loaderOverlay.hide()
        PatioService.cadastrar(request, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      prepararDados () {
        const clearNumber = str => str.replace(/\D/g, '')
        const tmp = {...this.data}
        tmp.cep = clearNumber(tmp.cep)
        tmp.cnpj = clearNumber(tmp.cnpj)
        tmp.telefone = clearNumber(tmp.telefone)
        tmp.metaArrecadacao = +tmp.metaArrecadacao.replace(/^\D*/, '').replace(/\./, '').replace(/,/, '.')
        return {...tmp}
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Pátio</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.patios.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Código do pátio</label>
                <div class="col-sm-2">
                  <input type="number" class="form-control" v-model="data.codigo"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome" required/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Capacidade Total do Pátio</label>
                <div class="col-sm-8">
                  <input type="number" class="form-control" v-model="data.capacidade"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Porcentagem de Cobrança de Boleto</label>
                <div class="col-sm-1">
                  <input type="number" step="0.01" class="form-control" v-model="data.porcentagemBoleto" :disabled="data.naoEmitirBoleto" />
                </div>
                <div class="col-sm-1" style="height: 34px; display:flex; align-items: center ">
                  <span class="fa fa-percent"></span>
                </div>

                <div class="col-sm-6" style="height: 34px; display:flex; align-items: center ">
                  <label for="naoEmitirBoleto" class="i-checks m-b-none">
                    <input v-model="data.naoEmitirBoleto" type="checkbox" id="naoEmitirBoleto"
                           tabindex="0" aria-checked="false"
                           aria-invalid="false"><i></i>
                  </label>
                  <label for="naoEmitirBoleto">Não emitir boleto</label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Meta de Veículos por Mês</label>
                <div class="col-sm-8">
                  <input type="number" class="form-control" v-model="data.metaVeiculos"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Meta de Arrecadação no Mês</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.metaArrecadacao" v-money="money"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Inscrição Municipal</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.inscricaoMunicipal"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Endereço</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.endereco"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Complemento</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.complemento"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Estado</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.estado">
                    <option :value="null" disabled>Selecione</option>
                    <option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{estado.nome}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Cidade</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cidade"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">CEP</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cep" v-mask="'##.###-###'"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Observações</label>
                <div class="col-sm-8">
                  <textarea rows="3" class="form-control" v-model="data.observacao"></textarea>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Horário de Atendimento</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.horarioAtendimento"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Razão Social</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.razaoSocial"/>
                  <span class="lembrete">Nome que vai aparecer na guia de impressão da GRV Eletrônica</span>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">CNPJ</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cnpj" v-mask="'##.###.###/####-##'"/>
                  <span class="lembrete">O CNPJ vai aparecer na gua de impressão da GRV Eletrônica</span>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Telefone</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.telefone"/>
                  <span class="lembrete">Telefone para atendimento</span>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.patios.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style>
  .lembrete {
    font-size: smaller;
  }
</style>



// WEBPACK FOOTER //
// NovoPatio.vue?05e8a32c